export const INPUT_TYPES = {
  upload: 'upload',
  description: 'comicDescription',
};
